import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';
import { Input } from './ui/input';
import { Button } from './ui/button';
import { useFocusOnMount, useScrollToBottom } from '../hooks/useDomEffects';

export const ChatPanel = ({ messages, input, setInput, busy, error, send, close, reset }) => {
  const log = useRef(null);
  const field = useRef(null);
  useFocusOnMount(field);
  useScrollToBottom(log, messages, busy, error);
  return <section id="leah-chat-panel" role="dialog" aria-label="Chat with Leah, the JOS Criminal Law assistant" className="leah-dialog leah-panel-enter" data-testid="leah-chat-panel">
    <header className="leah-dialog-header" data-testid="leah-chat-header">
      <div><p className="leah-name" data-testid="leah-name">Leah</p><p className="leah-status" data-testid="leah-status">Online</p></div>
      <div className="leah-header-actions">
        <button type="button" className="leah-new" data-testid="leah-new-chat" onClick={() => { reset(); field.current?.focus(); }}>NEW CHAT</button>
        <button type="button" aria-label="Close chat" title="Close chat" data-testid="leah-close-chat" onClick={close}><X size={16} /></button>
      </div>
    </header>
    <div ref={log} className="leah-log" role="log" aria-live="polite" aria-label="Conversation with Leah" data-testid="leah-conversation">
      {!messages.length && <p className="leah-welcome" data-testid="leah-welcome">Hi, I’m Leah. Tell me a little about your situation and I’ll help point you to the right next step. For general information only — not legal advice.</p>}
      {messages.map((message, i) => <div key={message.id} className={`leah-message ${message.role}`} data-testid={`leah-message-${i}`}>
        <p data-testid={`leah-message-text-${i}`}>{message.message}</p>
        {message.links?.map((link, j) => <Link key={link.href} to={link.href} className="leah-link" data-testid={`leah-message-link-${i}-${j}`} onClick={close}>{link.label} →</Link>)}
      </div>)}
      {busy && <p className="leah-welcome" data-testid="leah-typing">Leah is replying…</p>}
      {error && <p role="alert" className="consultation-error" data-testid="leah-error">{error}</p>}
    </div>
    <form className="leah-compose" onSubmit={send} data-testid="leah-message-form">
      <div className="leah-compose-row">
        <label htmlFor="leah-chat-input" className="sr-only" data-testid="leah-input-label">Type your message to Leah</label>
        <Input ref={field} id="leah-chat-input" value={input} maxLength={2000} autoComplete="off" placeholder="Type your message" data-testid="leah-message-input" onChange={e => setInput(e.target.value)} />
        <Button type="submit" className="leah-send" disabled={busy || !input.trim()} data-testid="leah-send-message">Send</Button>
      </div>
      <p className="leah-disclaimer" data-testid="leah-disclaimer">Messages here don’t create an attorney–client relationship.</p>
    </form>
  </section>;
};